var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rate_s",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6329",
    "data-name": "Group 6329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46290",
    "data-name": "Path 46290",
    d: "M0,0H18V18H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46291",
    "data-name": "Path 46291",
    d: "M0,0H18V18H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    "data-name": "Group 6330",
    transform: "translate(2.582 2.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46292",
    "data-name": "Path 46292",
    d: "M9.861,13.846l3.112,1.883a.748.748,0,0,0,1.118-.81l-.825-3.54,2.753-2.385a.748.748,0,0,0-.428-1.312l-3.622-.307L10.551,4.028a.75.75,0,0,0-1.38,0L7.753,7.366l-3.622.307A.748.748,0,0,0,3.7,8.986l2.753,2.385-.825,3.54a.748.748,0,0,0,1.118.81Z",
    transform: "translate(-3.443 -3.573)",
    fill: "#f60"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateS);
export default __webpack_public_path__ + "static/media/rate_s.045e0191a11e66c01a5c1e1f4fd1a0e0.svg";
export { ForwardRef as ReactComponent };